module.exports = __webpack_public_path__ + "media/site_templates/www.asbestosremoval.business/images/our_services_3-5ad698a9a899c23eb91490ad1dc7fefd.jpg";